import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { PlatformSidebar } from "@/components/shell/platform-sidebar";
import { SkipLink } from "@/components/shell/skip-link";
import { AppMain } from "@/components/shell/app-main";
import { Topbar } from "@/components/shell/topbar";
import { CommandPalette } from "@/components/shell/command-palette";

export default function PlatformLayout({ children }: { children: React.ReactNode }) {
  return (
    <SidebarProvider style={{ "--sidebar-width": "236px", "--sidebar-width-icon": "56px" } as React.CSSProperties}>
      <SkipLink />
      <PlatformSidebar />
      <SidebarInset className="min-w-0 bg-canvas">
        <Topbar notifications={false} />
        <AppMain>
          <div className="mx-auto w-full max-w-[1360px] p-4 lg:p-6">{children}</div>
        </AppMain>
      </SidebarInset>
      {/* 2.854: a platform admin cannot read the scan-profile menu, so the
          palette does not ask (the AI entries fail open). */}
      <CommandPalette menu={false} />
    </SidebarProvider>
  );
}
